import { AdminAdDTOFields } from './admin/product'
import {
	PaymentAndInvoiceRecipient,
	Ad,
} from '../../../tikexModule/Types/models/team'
import { ProductBundle } from '../models/team'

export interface TeamDTOFields {
	_id: string
	barionPOSKey?: string
	barionPixelId?: string
	bchXPub?: string
	billingoApiKey?: string
	billingoBankAccountUid?: string
	billingoPrefix?: string
	billingoProductUid?: string
	billingoPublicKey?: string
	billingoVatKey?: string
	//calendars?: { [id: string]: ProductBundle }
	commissionFee?: string
	createdAt: Date
	defaultBusinessName?: string
	defaultPaymentProviderRegistration?: string
	designerIntroduction?: string
	email?: string
	facilitatorCommissionFee?: string
	forms?: { [key: string]: Form }
	free3MonthPeriodStartedAt?: Date
	gdpr?: string
	groupName?: string
	invoiceFulfillmentDate?: string
	isLocked?: boolean
	isOrderStatusUsed?: boolean
	isTaxCodeVisible: boolean
	languages?: string[]
	locale?: string
	location?: string
	name?: string
	passBarionId?: string
	passTypes?: { [key: string]: PassType }
	paymentAndInvoiceRecipients?: { [key: string]: PaymentAndInvoiceRecipient }
	paymentProviderName?: string
	phone?: string
	ads: { [key: string]: AdminAdDTOFields }
	scope?: Scope
	selectedInvoiceProvider?: string
	selectedPlan?: string
	shortId?: string
	socialNetworkContact?: string
	szamlazzhuSzamlaAgentKulcs?: string
	passSzamlazzhuVatKey?: string
	translations?: { [key: string]: { [key: string]: string } }
	type?: string
	userRating?: string
	usersWithPermission: { [key: string]: Scope }
}

export interface PassType {
	price: string
	capacity: number
	expirationDays: number
	invoiceDescription?: string
	additionalInfo?: string
	hidden?: boolean
}

export interface Scope {
	range: string
	value?: string
}

export interface Form {
	formFields: { [key: string]: FormField }
	postId?: string
	name?: string
}

export interface FormField {
	name?: string
	type: string
	options?: { [key: string]: FormFieldOption }
	options2?: { [key: string]: FormFieldOption }
	selectedOption?: string
	visibleIfIndIsVisible?: number
	ind?: number
	mandatory: boolean
	dateCreatedAt?: Date
	selectItemOtherArbitraryValueEnable?: boolean
	regex?: string
	hasImage?: boolean
	defaultFormFieldOptionId?: string
	details?: string
	nameByLang?: { [key: string]: string }
	detailsByLang?: { [key: string]: string }
	imgId?: string
	pricingOptionId?: string
	hidden?: boolean
}

export interface FormFieldOption {
	name?: string
	colorCode?: string
	hasImage?: boolean
	nameByLang?: { [key: string]: string }
	ind?: number
}

export const SzamlazzhuVatKey = [
	'AAM',
	'27',
	'MAA',
	'18',
	'5',
	'TAHK',
	'EUFAD37',
	'HO',
]

export const Currency = {
	HUF: 'HUF',
	EUR: 'EUR',
	USD: 'USD',
} as const

export const InvoiceProvider = {
	No: '-',
	Szamlazzhu: 'szamlazz.hu',
} as const

export const Locale = {
	hu: 'hu-HU',
	en: 'en-US',
	es: 'es-ES',
	de: 'de-DE',
	fr: 'fr-FR',
} as const
